
export { G as LayoutFeaturedResources } from "./main-UMBqf2Ea.js"